var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icone mesagem" } }, [
        _c("path", {
          attrs: {
            id: "Mask",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M15.9996 12.9992C15.4476 12.9992 14.9996 12.5512 14.9996 11.9992C14.9996 11.4472 15.4476 10.9992 15.9996 10.9992C16.5516 10.9992 16.9996 11.4472 16.9996 11.9992C16.9996 12.5512 16.5516 12.9992 15.9996 12.9992ZM11.9996 12.9992C11.4476 12.9992 10.9996 12.5512 10.9996 11.9992C10.9996 11.4472 11.4476 10.9992 11.9996 10.9992C12.5516 10.9992 12.9996 11.4472 12.9996 11.9992C12.9996 12.5512 12.5516 12.9992 11.9996 12.9992ZM7.99961 12.9992C7.44761 12.9992 6.99961 12.5512 6.99961 11.9992C6.99961 11.4472 7.44761 10.9992 7.99961 10.9992C8.55161 10.9992 8.99961 11.4472 8.99961 11.9992C8.99961 12.5512 8.55161 12.9992 7.99961 12.9992ZM19.0706 4.92817C16.7866 2.64417 13.6256 1.62517 10.3966 2.12417C6.31961 2.76017 2.93961 6.04417 2.17661 10.1112C1.80961 12.0692 2.02061 14.0632 2.78761 15.8762C2.88561 16.1062 2.91561 16.3222 2.87661 16.5152L2.01961 20.8032C1.95361 21.1312 2.05661 21.4702 2.29261 21.7062C2.48161 21.8952 2.73661 21.9992 2.99961 21.9992C3.06461 21.9992 3.13061 21.9932 3.19561 21.9792L7.47861 21.1232C7.72461 21.0762 7.96361 21.1452 8.12261 21.2112C9.93661 21.9782 11.9306 22.1882 13.8876 21.8222C17.9546 21.0592 21.2386 17.6792 21.8746 13.6022C22.3776 10.3742 21.3556 7.21317 19.0706 4.92817Z",
            fill: _vm.color
          }
        }),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "luminance" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "2",
              y: "2",
              width: "20",
              height: "20"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M15.9996 12.9992C15.4476 12.9992 14.9996 12.5512 14.9996 11.9992C14.9996 11.4472 15.4476 10.9992 15.9996 10.9992C16.5516 10.9992 16.9996 11.4472 16.9996 11.9992C16.9996 12.5512 16.5516 12.9992 15.9996 12.9992ZM11.9996 12.9992C11.4476 12.9992 10.9996 12.5512 10.9996 11.9992C10.9996 11.4472 11.4476 10.9992 11.9996 10.9992C12.5516 10.9992 12.9996 11.4472 12.9996 11.9992C12.9996 12.5512 12.5516 12.9992 11.9996 12.9992ZM7.99961 12.9992C7.44761 12.9992 6.99961 12.5512 6.99961 11.9992C6.99961 11.4472 7.44761 10.9992 7.99961 10.9992C8.55161 10.9992 8.99961 11.4472 8.99961 11.9992C8.99961 12.5512 8.55161 12.9992 7.99961 12.9992ZM19.0706 4.92817C16.7866 2.64417 13.6256 1.62517 10.3966 2.12417C6.31961 2.76017 2.93961 6.04417 2.17661 10.1112C1.80961 12.0692 2.02061 14.0632 2.78761 15.8762C2.88561 16.1062 2.91561 16.3222 2.87661 16.5152L2.01961 20.8032C1.95361 21.1312 2.05661 21.4702 2.29261 21.7062C2.48161 21.8952 2.73661 21.9992 2.99961 21.9992C3.06461 21.9992 3.13061 21.9932 3.19561 21.9792L7.47861 21.1232C7.72461 21.0762 7.96361 21.1452 8.12261 21.2112C9.93661 21.9782 11.9306 22.1882 13.8876 21.8222C17.9546 21.0592 21.2386 17.6792 21.8746 13.6022C22.3776 10.3742 21.3556 7.21317 19.0706 4.92817Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "24", height: "24", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }